import apiSlice from "./apiSlice";
const authApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserInfo: builder.query({
            query: (req) => ({
                url: `account/user/info`,
            }),
        }),

    }),
});

export const {
    useLazyGetUserInfoQuery,
} = authApiSlice;
